import { render, staticRenderFns } from "./GoodsPromotionIndex.vue?vue&type=template&id=a28762da&scoped=true"
import script from "./GoodsPromotionIndex.vue?vue&type=script&lang=js"
export * from "./GoodsPromotionIndex.vue?vue&type=script&lang=js"
import style0 from "./GoodsPromotionIndex.vue?vue&type=style&index=0&id=a28762da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28762da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28762da')) {
      api.createRecord('a28762da', component.options)
    } else {
      api.reload('a28762da', component.options)
    }
    module.hot.accept("./GoodsPromotionIndex.vue?vue&type=template&id=a28762da&scoped=true", function () {
      api.rerender('a28762da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/goods_promotion/GoodsPromotionIndex.vue"
export default component.exports